import {CoordinatesProps} from 'shared/types/coordinates';

const getCurrentPosition = (): Promise<CoordinatesProps | undefined> => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(undefined);

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const {latitude, longitude} = position.coords;
        resolve({latitude, longitude});
      },
      () => resolve(undefined),
      {enableHighAccuracy: true, timeout: 10000, maximumAge: 0},
    );
  });
};

export default getCurrentPosition;
